<template>
  <div>
    <FormSelect
      v-if="followUpOrderTypeOptions.length > 0"
      :name="$t('meta.followUpOrderType')"
      @input="$emit('input', $event)"
      :value="value"
      :loading="loading"
      :options="followUpOrderTypeOptions"
    />
  </div>
</template>

<script>
import FormSelect from '@/components/Form/Select/index.vue'

import configApi from '@/api/config'
import { ORDER_TYPE_OPTIONS } from '@/api/orders'

export default {
  components: { FormSelect },
  props: {
    value: { type: String, default: null },
    order: { type: Object, required: true },
  },
  data: () => ({
    loading: true,
    validFollowUpOrderTypes: null,
  }),
  computed: {
    followUpOrderTypeOptions() {
      return ORDER_TYPE_OPTIONS.filter(type => this.validFollowUpOrderTypes?.includes(type.value)).map(option => ({
        label: this.$t(option.label_i18n),
        value: option.value,
      }))
    },
  },
  watch: {
    'order.type': {
      handler() {
        const defaults = this.order.company.settings.default_follow_up_order_types

        // set the default but only if the order is new (no uuid)
        if (this.order.uuid == null && defaults && defaults[this.order.type])
          this.$emit('input', defaults[this.order.type])
      },
      immediate: true,
    },
  },
  async mounted() {
    const config = await configApi.get()

    this.validFollowUpOrderTypes = config.valid_follow_up_order_types[this.order.type]

    this.loading = false
  },
}
</script>
